var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVacancy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 46,
    viewBox: "0 0 38 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.788 15.7999H36.5788V44.9733L1.41946 44.9729V15.9L18.9996 1.482L36.6554 15.9643L36.7886 15.8005H36.5794H36.7886L36.9224 15.6381L19.1336 1.04748C19.0572 0.984173 18.9457 0.984173 18.8673 1.04748L1.07839 15.639L1.00098 15.8014V45.1835L1.06325 45.3321L1.2112 45.3934H36.7898L36.9374 45.3321L37 45.1835L36.9994 15.8005L36.923 15.6381L36.7888 15.8005",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.788 15.7999H36.5788V44.9733L1.41946 44.9729V15.9L18.9996 1.482L36.6554 15.9643L36.7886 15.8005H36.5794H36.7886L36.9224 15.6381L19.1336 1.04748C19.0572 0.984173 18.9457 0.984173 18.8673 1.04748L1.07839 15.639L1.00098 15.8014V45.1835L1.06325 45.3321L1.2112 45.3934H36.7898L36.9374 45.3321L37 45.1835L36.9994 15.8005L36.923 15.6381L36.7888 15.8005",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.21022 16.0096H36.7888C36.9038 16.0096 36.9984 15.916 36.9984 15.7993C36.9984 15.6841 36.9048 15.5891 36.7888 15.5891L1.21022 15.5895C1.0953 15.5895 1 15.6837 1 15.7997C0.999657 15.916 1.09427 16.0096 1.21022 16.0096",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.21022 16.0096H36.7888C36.9038 16.0096 36.9984 15.916 36.9984 15.7993C36.9984 15.6841 36.9048 15.5891 36.7888 15.5891L1.21022 15.5895C1.0953 15.5895 1 15.6837 1 15.7997C0.999657 15.916 1.09427 16.0096 1.21022 16.0096",
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.21022 30.6011H36.7888C36.9038 30.6011 36.9984 30.5078 36.9984 30.3919C36.9984 30.2759 36.9048 30.1824 36.7888 30.1824H1.21022C1.0953 30.1824 1 30.2759 1 30.3919C0.999657 30.5065 1.09427 30.6011 1.21022 30.6011",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.21022 30.6011H36.7888C36.9038 30.6011 36.9984 30.5078 36.9984 30.3919C36.9984 30.2759 36.9048 30.1824 36.7888 30.1824H1.21022C1.0953 30.1824 1 30.2759 1 30.3919C0.999657 30.5065 1.09427 30.6011 1.21022 30.6011",
    stroke: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1914 15.7999V30.3915C15.1914 30.506 15.2857 30.6007 15.4016 30.6007C15.5176 30.6007 15.6119 30.5074 15.6119 30.3915L15.6115 15.7999C15.6115 15.6847 15.5172 15.5904 15.4013 15.5904C15.2853 15.5908 15.1914 15.6843 15.1914 15.7999",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1914 15.7999V30.3915C15.1914 30.506 15.2857 30.6007 15.4016 30.6007C15.5176 30.6007 15.6119 30.5074 15.6119 30.3915L15.6115 15.7999C15.6115 15.6847 15.5172 15.5904 15.4013 15.5904C15.2853 15.5908 15.1914 15.6843 15.1914 15.7999",
    stroke: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 32,
    width: 34,
    height: 12,
    stroke: "#FF0505",
    strokeWidth: 2,
    strokeDasharray: "4 4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVacancy);
export default __webpack_public_path__ + "static/media/vacancy.fd245d5075243e65df16c8be5f0a8abf.svg";
export { ForwardRef as ReactComponent };